// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__3Ut_k","logo":"Navbar_logo__22tl6","logoIcon":"Navbar_logoIcon__1oTl9","navLinks":"Navbar_navLinks__1CSkh","navElements":"Navbar_navElements__36CDn"};